import React from "react";

function ThankYouCompanyRegistration() {
  return (
    <div 
      className="company-form-container mx-auto mt-16 px-8 py-10 shadow-xl rounded-2xl border border-gray-200"
      style={{
        maxWidth: "600px",
        margin: "2rem auto",
        padding: "2rem 3rem",
        background: "#e8f3f9",
        boxShadow: "0 0 5px rgba(0, 0, 0, 0.1)"
      }}
    >
      <div className="text-center">
        <img 
          src="/assets/img/order-summary.png" 
          alt="Order Summary" 
          style={{ width: '140px', height: '80px' }}
          className="mx-auto mb-2"
        />
        <h2 className="text-2xl font-semibold text-black mb-3">
          Thank You!
        </h2>
        <p className="text-gray-200 mb-4">
          Your application has been successfully submitted and is currently under review
          by our team. Our administrators will verify the details you've provided.
        </p>
      </div>

      <div className="text-gray-200 space-y-3 leading-relaxed">
        <ul className="list-disc pl-5 space-y-2">
          <li>
            Our team will review your application
            within the next <strong>2–3 business days</strong>.
          </li>
          <li>
            Upon approval, you'll receive an
            email with login credentials to access your admin panel.
          </li>
        </ul>

        <p className="text-center">
          If you have any questions in the meantime, feel free to reach out at{" "}
          <a
            href="mailto:admin@bookinclass.co.uk"
            className="text-blue-300 font-medium hover:underline"
          >
            admin@bookinclass.co.uk
          </a>.
        </p>
      </div>
    </div>
  );
}

export default ThankYouCompanyRegistration;
